import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import webservice from '../../../../Service/webservice';
import { AesDecrypt, AesEncrypt, keyPromise } from '../../../../Service/crypto';
import api from '../../../../api';

interface Document {
  id: number;
  appointment: string;
  ClientName: string;
  insure_status: string;
  xml_conversion: string;
  template_creation: string;
  Patient_Parent_id: string;
  patient: {
    dob: string;
    name: string;
    first_name: string;
    last_name: string;
  };
  payer: {
    name: string;
  };
  plan: {
    name: string;
  };
  uploaded_date: string;
}

interface GetDataParams {
  q?: string;
  insurance?: string;
  perPage?: number;
  page?: number;
  status?: string | null;
  sort?: string;
  sortColumn?: keyof Document; // Updated to keyof Document
  selectedBotStatus?: any;
  startDate?: string | null;
  endDate?: string | null;
}

interface GetDataResponse {
  params: GetDataParams;
  data: Document[];
  allData: Document[];
  totalPages: number;
  no_Data: string | [];
}


const paginateArray = (array: Document[], perPage: number, page: number): Document[] =>
  array.slice((page - 1) * perPage, page * perPage);


export const getData = createAsyncThunk<GetDataResponse, GetDataParams>(
  'Appmenu/getData',
  async (params) => {

    const UserType = localStorage.UserType;
    let Id: string | null = '';
    const key = await keyPromise
    if (UserType === "MOS") {
      Id = localStorage.id;
    } else if (UserType === "Vendor") {
      Id = localStorage.VendorId;
    } else if (UserType === "Client") {
      Id = localStorage.ClientId;
    }

    let dataParams: Record<string, any> = {};

    const { q = '', perPage = 10, page = 1, sort, sortColumn, insurance } = params;
    dataParams['UserType'] = UserType;
    dataParams['UserID'] = Id;
    dataParams['perPage'] = perPage;
    dataParams['page'] = page;
    dataParams['sort'] = sort;
    dataParams['sortColumn'] = sortColumn;
    dataParams['q'] = q;
    dataParams['insurance'] = insurance;
    dataParams['startDate'] = params.startDate ? params.startDate : null;
    dataParams['endDate'] = params.endDate ? params.endDate : null;
    dataParams['selectedBotStatus'] = params.selectedBotStatus ? params.selectedBotStatus : '';

    // Convert dataParams to a JSON string before encryption
    const dataParamsString = JSON.stringify(dataParams);
    const EncParams = await AesEncrypt(key, dataParamsString);

    try {
      const response = await api.fetch('api/Patient/GetPatientList', {
        method: 'POST',
        body: JSON.stringify({ EncParams })
      });

      const jsonResponse = await response.json();
      const key = await keyPromise
      const Response = await AesDecrypt(key, jsonResponse);

      let Decryptdata = Response?.response_data;
      if (Response?.error) console.warn('Patients listing error:', Response.error);

      if (Array.isArray(Decryptdata)) {
        Decryptdata = Decryptdata.sort((a, b) => {
          return new Date(b.uploaded_date).getTime() - new Date(a.uploaded_date).getTime();
        });
      }

      // Anything other than a list (backend error, expired session) is shown as "no records"
      if (!Array.isArray(Decryptdata) || Decryptdata.length === 0) {
        return {
          params,
          data: [],
          allData: [],
          totalPages: 0,
          no_Data: 'There is no Record Found',
        };
      } else {
        const totalCount = Response.count;
        const res = Response.response_data;

        return {
          params,
          data: res,
          allData: res,
          totalPages: totalCount,
          no_Data: [],
        };
      }
    } catch (err) {
      console.error(err);
      throw err;
    }
  }
);

export const Get_permission = createAsyncThunk(
  'Bulkupload/Get_permission',
  async (data: any, { dispatch, getState }) => {
    const response = await api.fetch('api/Get_permission', {
      method: 'POST',
      body: JSON.stringify({ data })
    }).then((response) => response.json());
    return response;
  }
);
export const patientdetails = createAsyncThunk('Bulkupload/patientdetails', async (payloadid: any, { dispatch, getState }) => {
  const response = await api.fetch('api/uploadDocument/patientdetails', {
    method: 'POST',
    body: JSON.stringify({ payloadid })
  })
    .then((response) => response.json())
  return response
})

interface AppMenuState {
  data: Document[];
  total: number;
  params: GetDataParams;
  allData: Document[];
  no_Data: string | [];
}

const initialState: AppMenuState = {
  data: [],
  total: 0,
  params: {},
  allData: [],
  no_Data: '',
};

export const PatientSlice = createSlice({
  name: 'Bulkupload',
  initialState,
  reducers: {
    updateData: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getData.fulfilled, (state, action: PayloadAction<GetDataResponse>) => {
      state.data = action.payload.data;
      state.allData = action.payload.allData;
      state.total = action.payload.totalPages;
      state.params = action.payload.params;
      state.no_Data = action.payload.no_Data;
    });
  },
});

export default PatientSlice.reducer;

